import $ from 'jquery';

export const onTotalChangesSinceLastSaveChange = (
  totalChangesSinceLastSave
) => {
  if (totalChangesSinceLastSave === 0) {
    $('#editor-menu-salva').addClass('btn-success').removeClass('btn-warning');
  } else {
    $('#editor-menu-salva').addClass('btn-warning').removeClass('btn-success');
  }
};
